import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";

const quickLinks = ["home", "services", "about", "contact"];
const listedServices = [
  "Web Development",
  "Mobile Apps",
  "Cloud & DevOps",
  "Cybersecurity",
  "AI & Automation",
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="bg-slate-950 pt-16 pb-8 text-slate-300">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-4 flex items-center gap-3">
              <div className="h-14 w-14 rounded-3xl p-3">
                <img src={logo} alt="Nexora Ventures logo" className="h-full w-full object-contain" />
              </div>
              <div>
                <p className="text-2xl font-bold text-white">Nexora Ventures</p>
                <p className="text-sm text-slate-400">Digital innovation studio</p>
              </div>
            </div>

            <p className="max-w-md text-sm text-slate-400">
              We provide digital services, cloud solutions, automation, and security-focused technology delivery for businesses in the UAE and beyond.
            </p>

            <div className="mt-6 flex gap-3">
              {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-800 text-slate-300 transition hover:bg-blue-600 hover:text-white"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">Quick Links</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link}>
                  <button
                    onClick={() => handleNav(link)}
                    className="text-sm capitalize text-slate-400 transition hover:text-blue-400"
                  >
                    {link}
                  </button>
                </li>
              ))}
              <li>
                <Link to="/pricing" className="text-sm text-slate-400 transition hover:text-blue-400">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">Compliance & Policies</h4>
            <ul className="flex flex-col gap-3 text-sm text-slate-400">
              <li>
                <Link to="/privacy" className="transition hover:text-slate-300">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="transition hover:text-slate-300">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/aml-policy" className="transition hover:text-slate-300">
                  AML Policy
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="transition hover:text-slate-300">
                  Pricing & Refund Information
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="rounded-[2rem] border border-slate-800 bg-slate-900/70 px-5 py-5">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Payment Transparency</p>
              <p className="mt-2 text-sm leading-7 text-slate-300">
                We accept Visa and MasterCard payments in AED. Pricing, applicable taxes or charges, and refund eligibility are disclosed before payment confirmation. Nexora Ventures will NOT deal or provide any services or products to any OFAC (Office of Foreign Assets Control) sanctioned countries in accordance with the law of UAE.
              </p>
            </div>

            <div>
              <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Accepted Payments</p>
              <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-slate-400">
                <span className="rounded-full border border-slate-700 px-3 py-1 font-semibold text-white">
                  Visa
                </span>
                <span className="rounded-full border border-slate-700 px-3 py-1 font-semibold text-white">
                  MasterCard
                </span>
                <span>Secure online payment processing available.</span>
              </div>
              <div className="mt-4 text-sm text-slate-500">
                {listedServices.join(" • ")}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-6 md:flex-row">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} Nexora Ventures. All rights reserved.
          </p>
          <p className="text-center text-xs leading-6 text-slate-500 md:text-right">
            UAE governing law applies to website use, payment activity, and related disputes.
          </p>
        </div>
      </div>
    </footer>
  );
}
